import { render, staticRenderFns } from "./Mission.vue?vue&type=template&id=23fb2558&scoped=true&"
import script from "./Mission.vue?vue&type=script&lang=ts&"
export * from "./Mission.vue?vue&type=script&lang=ts&"
import style0 from "./Mission.vue?vue&type=style&index=0&id=23fb2558&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fb2558",
  null
  
)

export default component.exports